import { onBeforeMount } from 'vue'
import { findAll } from '@/api/sites.api'
import useAPI from '../useAPI'
import decoder from '@/decoders/sites'

export default (params = {}) => {
  const reactiveData = useAPI({
    request: findAll,
    params,
    decoder
  })

  onBeforeMount(reactiveData.execute)

  return reactiveData
}
